import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CustomIconButton, Tooltip } from "../../../components";
import { DeleteForever, Edit } from "../../../icons";

function EditMasterRecipientActions({ onEdit, onDelete }) {
  const { t } = useTranslation();

  return (
    <>
      <Tooltip title={t("Edit Recipient")}>
        <CustomIconButton component={Link} size="small" onClick={onEdit}>
          <Edit fontSize="small" />
        </CustomIconButton>
      </Tooltip>
      <Tooltip title={t("Delete Recipient")}>
        <CustomIconButton
          component={Link}
          size="small"
          color="error"
          onClick={onDelete}
        >
          <DeleteForever fontSize="small" />
        </CustomIconButton>
      </Tooltip>
    </>
  );
}

export default memo(EditMasterRecipientActions);
